import classes from './liveInteraktiv.module.css'
import { useState, useEffect } from 'react'
import classesK from '../kalkulatori.module.css'
import InfoBar from '../redesign/components/InfoBar'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import { areAllFieldsFilled } from './../../utils/calculationDataValidation'

const LiveInteraktiv = () => {
  const [error, setError] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [data, setData] = useState({
    values: {
      odds: ['', '', ''],
      oddsG: ['', ''],
      oddsB: ['', ''],
      stats: ['', '', '', '', '', ''],
      resultsHalf: ['', ''],
      minutes: [''],
    },
    results: {
      goals: ['', '', ''],
      score: ['', '', '', '', '', ''],
      teamStrength: ['', '', '', '', '', '', '', ''],
    },
  })
  const allFieldsFilled = areAllFieldsFilled(data.values)

  const clearFields = () => {
    setData({
      values: {
        odds: ['', '', ''],
        oddsG: ['', ''],
        oddsB: ['', ''],
        stats: ['', '', '', '', '', ''],
        resultsHalf: ['', ''],
        minutes: [''],
      },
      results: {
        goals: ['', '', ''],
        score: ['', '', '', '', '', ''],
        teamStrength: ['', '', '', '', '', '', '', ''],
      },
    })
    setShowInputArea(true)
  }

  const handleCalculateAll = () => {
    const odds = data?.values?.odds || ['', '', '']
    const oddsG = data?.values?.oddsG || ['', '']
    const oddsB = data?.values?.oddsB || ['', '']
    const stats = data?.values?.stats || ['', '', '', '', '', '']
    const resultsHalf = data?.values?.resultsHalf || ['', '']
    const minutes = data?.values?.minutes || ['']

    const [odd1Str, oddXStr, odd2Str] = [
      odds[0] || '',
      odds[1] || '',
      odds[2] || '',
    ]
    const [odd02Str, odd30Str] = oddsG
    const [odd12Str, odd20Str] = oddsB
    const [wins1Str, losses1Str, played1Str, wins2Str, losses2Str, played2Str] =
      stats
    const [score1Str, score2Str] = resultsHalf
    const [minutesStr] = minutes

    let b43 = isNaN(parseFloat(score1Str)) ? 0 : parseFloat(score1Str)
    let d43 = isNaN(parseFloat(score2Str)) ? 0 : parseFloat(score2Str)
    let i66 = parseFloat(oddXStr)
    let l66 = (1 / i66) * 100
    let j66 = parseFloat(odd2Str)
    let m66 = (1 / j66) * 100
    let h66 = parseFloat(odd1Str)
    let k66 = (1 / h66) * 100

    let n66 = k66 + l66 + m66 - 100

    let p66 = l66 - n66 / 3
    let s66 = (p66 * n66) / 100
    let v66 = l66 - s66

    let c78 = v66

    let o66 = k66 - n66 / 3
    let r66 = (o66 * n66) / 100

    let b78 = k66 - r66
    let g78 = (b78 + 79.21) / 2
    let h78 = (b78 + 14.18) / 2
    let i78 = (b78 + 6.61) / 2

    let ab78 = (g78 + h78 + i78 - 100) / 3

    let p78
    if (ab78 >= 0) {
      p78 = ab78
    } else {
      p78 = 100 - (g78 + h78 + i78) / 3
    }
    let s78
    if (p78 > 0) {
      s78 = g78 - p78
    } else {
      s78 = g78 + p78
    }

    let ae78 = Math.round(s78 * 100) / 100

    ae78 = ae78 * 1.001

    let q78

    let q66 = m66 - n66 / 3

    let t66 = (q66 * n66) / 100

    let w66 = m66 - t66

    let d78 = w66

    let j78 = (b78 + 36.42) / 2
    let k78 = (c78 + 35.6) / 2
    let l78 = (d78 + 27.98) / 2

    let ac78 = (j78 + k78 + l78 - 100) / 3

    if (ac78 >= 0) {
      q78 = ac78
    } else {
      q78 = 100 - (j78 + k78 + l78) / 3
    }

    let v78

    if (q78 > 0) {
      v78 = j78 - q78
    } else {
      v78 = j78 + q78
    }

    let m78 = (b78 + 10.7) / 2
    let n78 = (c78 + 18.91) / 2
    let o78 = (d78 + 70.4) / 2

    let ad78 = (m78 + n78 + o78 - 100) / 3

    let r78

    if (ad78 >= 0) {
      r78 = ad78
    } else {
      r78 = 100 - (m78 + n78 + o78) / 3
    }

    let y78

    if (r78 > 0) {
      y78 = m78 - r78
    } else {
      y78 = m78 + r78
    }

    let ak78 = y78 + 0.1

    let ah78 = v78 + 0.1

    let ae66

    if (b43 > d43) {
      ae66 = ae78
    } else if (b43 === d43) {
      ae66 = ah78
    } else {
      ae66 = ak78
    }
    let homeWin = !isNaN(ae66) ? parseFloat(ae66.toFixed(2)) : 0

    let u78

    if (p78 > 0) {
      u78 = i78 - p78
    } else {
      u78 = i78 + p78
    }

    let x78

    if (q78 > 0) {
      x78 = l78 - q78
    } else {
      x78 = l78 + q78
    }

    let aa78

    if (r78 > 0) {
      aa78 = o78 - r78
    } else {
      aa78 = o78 + r78
    }

    let ag78 = u78 + 0.1

    let aj78 = x78 + 0.1

    let am78 = aa78 + 0.1

    let ae68

    if (b43 > d43) {
      ae68 = ag78
    } else if ((b43 = d43)) {
      ae68 = aj78
    } else {
      ae68 = am78
    }

    let awayWin = !isNaN(ae68) ? parseFloat(ae68.toFixed(2)) : 0

    let drawResult = 100 - homeWin - awayWin
    drawResult = !isNaN(drawResult) ? parseFloat(drawResult.toFixed(2)) : 0

    let b32 = parseFloat(minutesStr)
    if (isNaN(b32)) b32 = 0

    let t33 = parseFloat(odd30Str)
    let u92 = t33

    let w92 = (1 / u92) * 100

    let r33 = parseFloat(odd02Str)

    let t92 = r33

    let v92 = (1 / t92) * 100

    let x92 = v92 + w92

    let y92 = x92 - 100

    let z92 = y92 / 2

    let n27 = parseFloat(wins1Str)

    let p27 = parseFloat(losses1Str)

    let o90 = p27

    let n90 = n27

    let o94 = (n90 + o90) / o90

    let r27 = parseFloat(losses2Str)

    let p90 = r27

    let t27 = parseFloat(wins2Str)

    let q90 = t27

    let s29 = parseFloat(played2Str)

    let q92 = s29

    let q94 = (p90 + q90) / q92

    let o96 = (o94 + q94) / 2

    let p84 = o96

    let ae92 = p84

    let ab92 = w92 - z92

    let ad92

    if (ab92 < 0) {
      ad92 = 0
    } else {
      ad92 = ab92
    }

    let af92 = (ad92 * 5) / 100

    let ag92 = (ae92 + af92) / 2

    let b104 = ag92 / 90

    let e102 = p84

    let b108 = e102 * 0.55
    let c108 = b108 - b104
    let d108 = c108 - b104
    let e108 = d108 - b104
    let f108 = e108 - b104
    let g108 = f108 - b104
    let h108 = g108 - b104
    let i108 = h108 - b104
    let j108 = i108 - b104
    let k108 = j108 - b104
    let l108 = k108 - b104
    let m108 = l108 - b104
    let n108 = m108 - b104
    let o108 = n108 - b104
    let p108 = o108 - b104
    let q108 = p108 - b104
    let r108 = q108 - b104
    let s108 = r108 - b104
    let t108 = s108 - b104
    let u108 = t108 - b104
    let v108 = u108 - b104
    let w108 = v108 - b104
    let x108 = w108 - b104
    let y108 = x108 - b104
    let z108 = y108 - b104
    let aa108 = z108 - b104
    let ab108 = aa108 - b104
    let ac108 = ab108 - b104
    let ad108 = ac108 - b104
    let ae108 = ad108 - b104
    let af108 = ae108 - b104
    let ag108 = af108 - b104
    let ah108 = ag108 - b104
    let ai108 = ah108 - b104
    let aj108 = ai108 - b104
    let ak108 = aj108 - b104
    let al108 = ak108 - b104
    let am108 = al108 - b104
    let an108 = am108 - b104
    let ao108 = an108 - b104
    let ap108 = ao108 - b104
    let aq108 = ap108 - b104
    let ar108 = aq108 - b104
    let as108 = ar108 - b104
    let at108 = as108 - b104

    let b110 = b32 === 46 ? e102 * 0.55 : 0
    let c110 = b32 === 47 ? b108 - b104 : 0
    let d110 = b32 === 48 ? c108 - b104 : 0
    let e110 = b32 === 49 ? d108 - b104 : 0
    let f110 = b32 === 50 ? e108 - b104 : 0
    let g110 = b32 === 51 ? f108 - b104 : 0
    let h110 = b32 === 52 ? g108 - b104 : 0
    let i110 = b32 === 53 ? h108 - b104 : 0
    let j110 = b32 === 54 ? i108 - b104 : 0
    let k110 = b32 === 55 ? j108 - b104 : 0
    let l110 = b32 === 56 ? k108 - b104 : 0
    let m110 = b32 === 57 ? l108 - b104 : 0
    let n110 = b32 === 58 ? m108 - b104 : 0
    let o110 = b32 === 59 ? n108 - b104 : 0
    let p110 = b32 === 60 ? o108 - b104 : 0
    let q110 = b32 === 61 ? p108 - b104 : 0
    let r110 = b32 === 62 ? q108 - b104 : 0
    let s110 = b32 === 63 ? r108 - b104 : 0
    let t110 = b32 === 64 ? s108 - b104 : 0
    let u110 = b32 === 65 ? t108 - b104 : 0
    let v110 = b32 === 66 ? u108 - b104 : 0
    let w110 = b32 === 67 ? v108 - b104 : 0
    let x110 = b32 === 68 ? w108 - b104 : 0
    let y110 = b32 === 69 ? x108 - b104 : 0
    let z110 = b32 === 70 ? y108 - b104 : 0
    let aa110 = b32 === 71 ? z108 - b104 : 0
    let ab110 = b32 === 72 ? aa108 - b104 : 0
    let ac110 = b32 === 73 ? ab108 - b104 : 0
    let ad110 = b32 === 74 ? ac108 - b104 : 0
    let ae110 = b32 === 75 ? ad108 - b104 : 0
    let af110 = b32 === 76 ? ae108 - b104 : 0
    let ag110 = b32 === 77 ? af108 - b104 : 0
    let ah110 = b32 === 78 ? ag108 - b104 : 0
    let ai110 = b32 === 79 ? ah108 - b104 : 0
    let aj110 = b32 === 80 ? ai108 - b104 : 0
    let ak110 = b32 === 81 ? aj108 - b104 : 0
    let al110 = b32 === 82 ? ak108 - b104 : 0
    let am110 = b32 === 83 ? al108 - b104 : 0
    let an110 = b32 === 84 ? am108 - b104 : 0
    let ao110 = b32 === 85 ? an108 - b104 : 0
    let ap110 = b32 === 86 ? ao108 - b104 : 0
    let aq110 = b32 === 87 ? ap108 - b104 : 0
    let ar110 = b32 === 88 ? aq108 - b104 : 0
    let as110 = b32 === 89 ? ar108 - b104 : 0
    let at110 = b32 === 90 ? as108 - b104 : 0

    let au110 =
      b110 +
      c110 +
      d110 +
      e110 +
      f110 +
      g110 +
      h110 +
      i110 +
      j110 +
      k110 +
      l110 +
      m110 +
      n110 +
      o110 +
      p110 +
      q110 +
      r110 +
      s110 +
      t110 +
      u110 +
      v110 +
      w110 +
      x110 +
      y110 +
      z110 +
      aa110 +
      ab110 +
      ac110 +
      ad110 +
      ae110 +
      af110 +
      ag110 +
      ah110 +
      ai110 +
      aj110 +
      ak110 +
      al110 +
      am110 +
      an110 +
      ao110 +
      ap110 +
      aq110 +
      ar110 +
      as110 +
      at110

    let midExpectedGoalTillEnd = au110

    if (isNaN(midExpectedGoalTillEnd)) {
      midExpectedGoalTillEnd = 0
    } else {
      midExpectedGoalTillEnd = midExpectedGoalTillEnd
    }

    let minExpectedGoalTillEnd = midExpectedGoalTillEnd / 2
    if (isNaN(minExpectedGoalTillEnd)) {
      minExpectedGoalTillEnd = 0
    } else {
      minExpectedGoalTillEnd = minExpectedGoalTillEnd
    }

    let j39 = midExpectedGoalTillEnd

    let maxExpectedGoalTillEnd = j39 * 1.5

    if (isNaN(maxExpectedGoalTillEnd)) {
      maxExpectedGoalTillEnd = 0
    } else {
      maxExpectedGoalTillEnd = maxExpectedGoalTillEnd
    }

    let f34 = homeWin

    let n34 = awayWin

    let f39 = minExpectedGoalTillEnd

    let b96 = 0

    let r43 = odd12Str

    let b92 = r43

    let d92 = 1 / b92

    let t43 = odd20Str

    let c92 = t43

    let e92 = 1 / c92

    let f92 = d92 + e92

    let g92 = f92 - 100

    let h92 = g92 / 2

    let i92 = d92 - h92

    let k92

    if (i92 < 0) {
      k92 = 0
    } else {
      k92 = i92
    }

    let n92 = k92 / 2.2

    let o92 = 100 - n92

    if (f34 >= n34) {
      b96 = (o92 * f39) / 100
    } else {
      b96 = 0
    }

    let c96 = f39 - b96

    let b103 = c96

    let b109

    if (f34 > n34) {
      b109 = b96
    } else {
      b109 = b103
    }

    let c109

    if (b96.toFixed(2) === b109.toFixed(2)) {
      c109 = c96
    } else {
      c109 = b103
    }

    let j27 = odd2Str

    let j88 = j27

    let m88 = (1 / j88) * 100

    let b27 = odd1Str

    let h88 = b27

    let k88 = (1 / h88) * 100

    let f27 = oddXStr

    let i88 = f27

    let l88 = (1 / i88) * 100

    let n88 = k88 + l88 + m88 - 100

    let q88 = m88 - n88 / 3

    let t88 = (q88 * n88) / 100

    let w88 = m88 - t88

    let m84 = w88

    let p88 = l88 - n88 / 3

    let s88 = (p88 * n88) / 100

    let v88 = l88 - s88

    let l84 = v88

    let f59 = m84

    let o88 = k88 - n88 / 3

    let r88 = (o88 * n88) / 100

    let u88 = k88 - r88

    let k84 = u88

    let f57 = k84

    let f58 = l84

    let f60 = f58 / 2

    let f62 = f59 + f60

    let f64 = (f62 * f39) / 100

    let f70 = f64

    let f61 = f60 + f57

    let f63 = (f39 * f61) / 100

    let f69 = f63

    let minLeft1 = parseFloat(f69).toFixed(0)
    let minRight1 = parseFloat(f70).toFixed(0)

    let min1 = `${minLeft1} : ${minRight1}`

    let minLeft2 = parseFloat(f63).toFixed(2)
    let minRight2 = parseFloat(f64).toFixed(2)

    let min2 = `${minLeft2} : ${minRight2}`

    let i109 = b109.toFixed(0)

    let l109 = i109 + b43

    let j109 = c109.toFixed(0)

    let m109 = parseFloat(j109) + parseFloat(d43)

    let minLeft3 = parseFloat(l109).toFixed(0)
    let minRight3 = parseFloat(m109).toFixed(0)

    let min3 = `${(parseFloat(minLeft1) + parseFloat(score1Str)).toFixed(
      0
    )} : ${parseFloat(minRight1) + parseFloat(score2Str)}`

    let min = []

    if (isNaN(minLeft1) || isNaN(minRight1)) {
      min.push('0 : 0')
    } else {
      min.push(min1)
    }

    if (isNaN(minLeft2) || isNaN(minRight2)) {
      min.push('0 : 0')
    } else {
      min.push(min2)
    }

    if (isNaN(minLeft3) || isNaN(minRight3)) {
      min.push('0 : 0')
    } else {
      min.push(min3)
    }

    let b98

    if (f34 >= n34) {
      b98 = (o92 * j39) / 100
    } else {
      b98 = 0
    }

    let c98 = j39 - b98

    let b105 = c98

    let b111

    if (f34 > n34) {
      b111 = b98
    } else {
      b111 = b105
    }

    let c111

    if (b98 === b111) {
      c111 = c98
    } else {
      c111 = b105
    }

    let j111 = c111.toFixed(0)

    let m111 = j111 + d43

    let i111 = b111.toFixed(0)

    let l111 = parseFloat(i111) + parseFloat(b43)

    let f66 = (j39 * f62) / 100

    let f72 = f66

    let f65 = (j39 * f61) / 100

    let f71 = f65

    let midLeft1 = parseFloat(f71).toFixed(0)
    let midRight1 = parseFloat(f72).toFixed(0)

    let midLeft2 = parseFloat(f65).toFixed(2)
    let midRight2 = parseFloat(f66).toFixed(2)

    let midLeft3 = parseFloat(l111).toFixed(0)
    let midRight3 = parseFloat(m111).toFixed(0)

    let mid1 = `${midLeft1} : ${midRight1}`
    let mid2 = `${midLeft2} : ${midRight2}`

    let mid3 = `${parseFloat(
      parseFloat(midLeft1) + parseFloat(score1Str)
    ).toFixed(0)} : ${parseFloat(
      parseFloat(midRight1) + parseFloat(score2Str)
    ).toFixed(0)}`

    let mid = []

    if (isNaN(midLeft1) || isNaN(midRight1)) {
      mid.push('0 : 0')
    } else {
      mid.push(mid1)
    }

    if (isNaN(midLeft2) || isNaN(midRight2)) {
      mid.push('0 : 0')
    } else {
      mid.push(mid2)
    }

    if (isNaN(midLeft3) || isNaN(midRight3)) {
      mid.push('0 : 0')
    } else {
      mid.push(mid3)
    }

    let n39 = maxExpectedGoalTillEnd

    let b100

    if (f34 >= n34) {
      b100 = (o92 * n39) / 100
    } else {
      b100 = 0
    }

    let c100 = parseFloat(n39) - parseFloat(b100)

    let b107 = c100

    let b113

    if (f34 > n34) {
      b113 = b100
    } else {
      b113 = b107
    }

    let c113

    if (b100 === b113) {
      c113 = c100
    } else {
      c113 = b107
    }

    console.log(b113, c113)

    let i113 = b113.toFixed(0)

    let l113 = parseFloat(i113) + parseFloat(b43)

    let j113 = c113.toFixed(0)

    let m113 = j113 + d43

    let f67 = (n39 * f61) / 100

    let f73 = f67

    let f68 = (n39 * f62) / 100

    let f74 = f68

    console.log(f73, f74, f67, f68, l113, m113)

    let maxLeft1 = parseFloat(f73).toFixed(0)
    let maxRight1 = parseFloat(f74).toFixed(0)

    let maxLeft2 = parseFloat(f67).toFixed(2)
    let maxRight2 = parseFloat(f68).toFixed(2)

    let maxLeft3 = parseFloat(l113).toFixed(0)
    let maxRight3 = parseFloat(m113).toFixed(0)

    let max1 = `${maxLeft1} : ${maxRight1}`
    let max2 = `${maxLeft2} : ${maxRight2}`
    let max3 = `${parseFloat(
      parseFloat(maxLeft1) + parseFloat(score1Str)
    ).toFixed(0)} : ${parseFloat(
      parseFloat(maxRight1) + parseFloat(score2Str)
    ).toFixed(0)}`

    let max = []

    if (isNaN(maxLeft1) || isNaN(maxRight1)) {
      max.push('0 : 0')
    } else {
      max.push(max1)
    }

    if (isNaN(maxLeft2) || isNaN(maxRight2)) {
      max.push('0 : 0')
    } else {
      max.push(max2)
    }

    console.log(maxLeft1, maxRight1, maxLeft2, maxRight2, maxLeft3, maxRight3)

    if (isNaN(maxLeft3) || isNaN(maxRight3)) {
      max.push('0 : 0')
    } else {
      max.push(max3)
    }

    console.log('max:', max)
    // Home team: Scored Goals per Game
    let snd = parseFloat(wins1Str) / parseFloat(played1Str) // snd

    let sod = parseFloat(losses1Str) / parseFloat(played1Str) // sod

    let sog = parseFloat(wins2Str) / parseFloat(played2Str) // sog

    let sng = parseFloat(losses2Str) / parseFloat(played2Str) // sng

    let sodg = (sod + sog) / 2 // sodg

    let sndg = (snd + sng) / 2 // sndg

    let sndsog = (snd + sog) / 2 // sndsog

    let sodsng = (sod + sng) / 2 // sodsng

    setData({
      ...data,
      results: {
        ...data.results,
        goals: [
          minExpectedGoalTillEnd.toFixed(2),
          midExpectedGoalTillEnd.toFixed(2),
          maxExpectedGoalTillEnd.toFixed(2),
        ],
        score: [
          `${min[0]} \n\n${min[1]}`, // Added newline character
          `${mid[0]} \n\n${mid[1]}`, // Added newline character
          `${max[0]} \n\n${max[1]}`, // Added newline character
          min[2],
          mid[2],
          max[2],
        ],
        teamStrength: [
          snd.toFixed(2),
          sod.toFixed(2),
          sng.toFixed(2),
          sog.toFixed(2),
          sndg.toFixed(2),
          sodg.toFixed(2),
          sndsog.toFixed(2),
          sodsng.toFixed(2),
        ],
      },
    })
  }

  useEffect(() => {
    if (allFieldsFilled) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [allFieldsFilled])

  const [showInputArea, setShowInputArea] = useState(true)
  const toggleInputArea = () => {
    if (!showInputArea) {
      clearFields()
      return
    } else {
      handleCalculateAll()
    }
    setShowInputArea((prev) => !prev)
  }

  console.log('data', data)

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={`Live interaktiv`} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={toggleInputArea} disabled={disabled}>
            {showInputArea ? 'Prikaži rezultate' : 'Unesi obračunske podatke'}
          </button>
        </div>
        {showInputArea && (
          <>
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>
                Upiši kvote za ishod meča
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'odds'}
                labelPrefix={['KI 1', 'KI X', 'KI 2']}
                step={['0.1', '0.1', '0.1']}
                min={['0.1', '0.1', '0.1']}
                type={['number', 'number', 'number']}
                setError={setError}
                rows={3}
              />
              <div className={classesK.sectionTitle}>Upiši kvote za golove</div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'oddsG'}
                labelPrefix={[
                  'Manje od 2.5 ( UG 0-2 )',
                  'Više od 2.5 ( UG 3+ )',
                ]}
                step={['0.1', '0.1']}
                min={['1', '1']}
                type={['number', 'number']}
                setError={setError}
                rows={1}
              />
              <div className={classesK.sectionTitle}>
                Upiši kvote za "Oba daju gol"
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'oddsB'}
                labelPrefix={[
                  'GG  ( oba tima daju gol na ut.)',
                  'NEGG ( min. jedan tim ne daje gol na ut. )',
                ]}
                step={['1', '1']}
                min={['1', '1']}
                type={['number', 'number']}
                setError={setError}
                rows={2}
              />
              <div className={classesK.sectionTitle}>
                Upiši br. golova / br. ut. za oba tima
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'stats'}
                labelPrefix={[
                  'DOM + (dom. dao golova)',
                  'DOM - (dom. primio golova)',
                  'DOM BR. (dom. odigrao utakmica)',
                  'GOST + (gost dao golova)',
                  'GOST - (gost primio golova)',
                  'GOST BR. (gost odigrao utakmica)',
                ]}
                step={['1', '1', '1', '1', '1', '1']}
                min={['1', '1', '1', '1', '1', '1']}
                type={[
                  'number',
                  'number',
                  'number',
                  'number',
                  'number',
                  'number',
                ]}
                setError={setError}
                rows={3}
              />
              <div className={classesK.sectionTitle}>
                Upiši rezultat prvog poluvremena
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'resultsHalf'}
                labelPrefix={[
                  'DOM ( dom. dao golova )',
                  'GOST ( gost dao golova)',
                ]}
                step={['1', '1']}
                min={['0', '0']}
                type={['number', 'number']}
                setError={setError}
                rows={2}
              />
              <div className={classesK.sectionTitle}>
                Upiši trenutni minut igre na utakmici
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'minutes'}
                labelPrefix={['MINUT( koji je minut utakmice ? )']}
                step={['1']}
                min={['0']}
                type={['number', 'number']}
                setError={setError}
                rows={1}
                calculation={handleCalculateAll}
              />
            </div>
          </>
        )}

        {!showInputArea && (
          <div className={classes.sectionResults}>
            <ResultsSection
              title={'Golovi'}
              subtitle={'XG ( očekivani br. golova do kraja utak.)'}
              results={data?.results?.goals.map((result) => `${result}`)}
              names={[
                'Minimalni očekivani broj golova',
                'Srednji očekivani broj golova',
                'Maksimalni očekivani broj golova',
              ]}
            />
            <ResultsSection
              title={'Tačan rezultat'}
              subtitle={'TR u preostalom vremenu utakmice'}
              results={[
                data?.results?.score[0],
                data?.results?.score[1],
                data?.results?.score[2],
              ]}
              names={[
                'Minimalan TR u preostalom vremenu',
                'Srednji TR u preostalom vremenu',
                'Maksimalan TR u preostalom vremenu',
              ]}
              rows={2}
            />
            <ResultsSection
              subtitle={'TR na kraju utakmice'}
              results={[
                data?.results?.score[3],
                data?.results?.score[4],
                data?.results?.score[5],
              ]}
              names={[
                'Predikcija minimalnog Tr-a na kraju ut. ',
                'Predikcija srednjeg Tr-a na kraju ut.',
                'Predikcija maximalnog Tr-a na kraju ut.',
              ]}
              rows={2}
            />

            <ResultsSection
              title={'Snage timova'}
              subtitle={'Snaga domaćina'}
              results={[
                data?.results?.teamStrength[0],
                data.results?.teamStrength[1],
              ]}
              names={['SND ( snaga napada )', 'SOD ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={'Snaga gosta'}
              results={[
                data?.results?.teamStrength[2],
                data.results?.teamStrength[3],
              ]}
              names={['SNG ( snaga napada )', 'SOG ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={'Snage oba tima zajedno'}
              results={[
                data?.results?.teamStrength[4],
                data.results?.teamStrength[5],
              ]}
              names={['SNDG ( snaga napada )', 'SODG ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={'Tim proseci odbrana i napada'}
              results={[
                data?.results?.teamStrength[6],
                data.results?.teamStrength[7],
              ]}
              names={[
                'SND+SOG ( snaga napada domaćin + snaga odbrane gost )',
                'SOD+SNG ( snaga napada domaćin + snaga odbrane gost )',
              ]}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default LiveInteraktiv
